module.exports = __webpack_public_path__ + "img/c026dd6.png";